import React from 'react';
import Typography from '@material-ui/core/Typography';
import { Dialog } from '@shared/components';
import { IconButton } from '@material-ui/core';
import SuccessIcon from '@assets/icons/done-green.svg';
import ErrorIcon from '@assets/icons/close-circle-red.svg';
import LoadingGif from '@assets/icons/spinner-144x144px.gif';
import useStyles from './style';
import clsx from 'clsx';

const ToastDialog = ({
  content = null,
  contentText = 'Success! Your new product has been added.',
  contentVariant = 'h6',
  heading = 'New Product Added',
  toastIcon = null,
  isLoading = false,
  onClose = null,
  open = false,
  isError = false,
  toastActions = <></>,
}) => {
  const classes = useStyles();
  return (
    <Dialog
      classes={{
        paper: classes.toastDialog,
      }}
      open={open}
      onClose={onClose}
      centered
    >
      <Dialog.Title hasClose={true}>
        <Typography variant='h5' className='pt-2 align-center bold-font'>
          {heading}
        </Typography>
      </Dialog.Title>
      <Dialog.Content>
        {content ? (
          <>{content}</>
        ) : (
          <div className='pt-2 align-center'>
            {isLoading ? (
              <IconButton disabled className='mt-8 mb-2'>
                <img
                  src={LoadingGif}
                  alt='success'
                  // width='96'
                />
              </IconButton>
            ) : (
              <IconButton disabled className='mt-8 mb-2'>
                <img
                  src={
                    toastIcon ? toastIcon : isError ? ErrorIcon : SuccessIcon
                  }
                  alt='success'
                  width='96'
                />
              </IconButton>
            )}
            <Typography
              variant={contentVariant}
              className={clsx('mt-2', {
                'mt-10': !toastIcon,
                'color-error': isError,
                [classes.successText]: !isError,
              })}
            >
              {contentText}
            </Typography>
            {toastActions}
          </div>
        )}
      </Dialog.Content>
    </Dialog>
  );
};

export default ToastDialog;
